import Vue from 'vue'
import App from './App.vue'

import "./common/css/app.css"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import store from './store'
import router from './router'

Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$store = store

new Vue({
  store,
  render: h => h(App),
  router: router
}).$mount('#app')
